import {
  type ComponentMetadata,
  parseComponentMetadata,
} from '@webflow/data-types';
import {map as mapValues} from '@packages/utilities/key-map';
import {Result} from '@packages/systems/wfdl';
import {getObject, getString} from '@packages/utilities/json';

import {createRpcMethod, trusted} from '@packages/utilities/jsonrpc';

type MetaInformationResult = Result.ResultType<
  string,
  {[key: string]: ComponentMetadata}
>;

const jsonParseFailure: MetaInformationResult = Result.Error(
  'Failed to parse compilation result'
);

export const evaluateComponents = createRpcMethod<
  {
    js: string;
    css: string;
    diagnostics: string;
  },
  MetaInformationResult
>({
  name: 'evaluateComponents',
  req: {
    encode: trusted,
    decode: trusted,
  },
  res: {
    encode: trusted,
    decode: (json) => {
      const obj = getObject(json);
      if (!obj || !obj.val) return jsonParseFailure;

      if (obj.tag === 'Error') {
        const value = getString(obj.val);
        if (!value) return jsonParseFailure;
        return Result.Error(value);
      }

      if (obj.tag === 'Ok') {
        const components = getObject(obj.val);
        if (!components) return jsonParseFailure;
        return Result.Ok(mapValues(parseComponentMetadata)(components));
      }

      return jsonParseFailure;
    },
  },
});
